var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-news-detail',{staticClass:"pt-news-detail__withData",attrs:{"newsDetail":_vm.newsDetail,"loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }